export var UploadTypeValues = [
    "this_only",
    "this_and_previous",
    "this_and_future",
    "all",
];
